import Axios from "axios";
import { SubmitButton } from "Components/Button";
import { Horizontal } from "Components/Horizontal";
import { LcpUserPageWrapper } from "Components/MainPageWrapper";
import { Section } from "Components/Section";
import { EnterKeyCatcher } from "Inputs/EnterKeyCatcher";
import { useFormWithSchema } from "Inputs/FormTools";
import { Textbox } from "Inputs/Textbox";
import { YupDefined } from "Inputs/Tools";
import React from "react";
import { useHistory } from "react-router-dom";
import { hasValue } from "Tools";
import * as Yup from "yup";
import { DashboardLink } from "./DashboardLink";
import { AdminPaths } from "./Paths";

export function useComponentFormik() {
  const history = useHistory();
  return useFormWithSchema({
    initialValues: {
      currentPassword: null,
      newPassword: null,
      confirmPassword: null,
    },
    onSubmit: async (values, handlers) => {
      const result = await Axios.post("/api/User/ChangePassword", {
        ...values,
      });
      if (hasValue(result.data.errors)) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        handlers.setErrors(result.data.errors);
        return;
      }
      history.push(AdminPaths.AdminDashboard);
    },
    validationSchema: Yup.object({
      currentPassword: YupDefined.string()
        .nullable()
        .required("Please enter your current password"),
      newPassword: YupDefined.string()
        .nullable()
        .label("New Password")
        .required()
        .min(8),
      confirmPassword: YupDefined.string()
        .nullable()
        .oneOf([Yup.ref("newPassword")], "Passwords must match")
        .required(),
    }),
  });
}

export function ChangePasswordPage() {
  const formik = useComponentFormik();
  return (
    <LcpUserPageWrapper documentTitle="Change Your Password">
      <Section title="Change Your Password" className="narrowFieldBodies2">
        <div style={{ marginBottom: "2em" }}>
          <em>Enter your new password.</em>
        </div>
        <EnterKeyCatcher handleSubmit={formik.handleSubmit}>
          <Horizontal label="Current Password" isRequired>
            <Textbox
              type="password"
              fieldProps={formik.field.getSubField("currentPassword")}
              placeholder="Current Password"
              style={{ flexGrow: 1 }}
            />
          </Horizontal>
          <Horizontal label="New Password" isRequired>
            <Textbox
              type="password"
              fieldProps={formik.field.getSubField("newPassword")}
              placeholder="New Password"
              style={{ flexGrow: 1 }}
            />
          </Horizontal>
          <Horizontal isRequired>
            <Textbox
              type="password"
              fieldProps={formik.field.getSubField("confirmPassword")}
              placeholder="Confirm Password"
              style={{ flexGrow: 1 }}
            />
          </Horizontal>
          <div className="has-text-centered" style={{ marginTop: "1em" }}>
            <SubmitButton
              isSubmitting={formik.isSubmitting}
              onClick={formik.submitForm}
            />
          </div>
        </EnterKeyCatcher>
        <DashboardLink />
      </Section>
    </LcpUserPageWrapper>
  );
}
